import React from 'react';

const AvexaEnhancesSection = () => {
  const features = [
    {
      id: 1,
      title: 'Parents receive vaccination reminders',
      src: '/assets/platformchild/5section-1.svg',
      alt: 'vaccination'
    },
    {
      id: 2,
      title: 'AI detects early signs of developmental delays',
      src: '/assets/platformchild/5section-2.svg',
      alt: 'Happy baby eating with parent watching'
    },
    {
      id: 3,
      title: 'Doctors access full child records',
      src: '/assets/platformchild/5section-3.svg',
      alt: 'Doctor showing tablet to family with child'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 blue-bg">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="  font-bold text-gray-900 mb-3 md:mb-4">
            <span className="">How Avexa Enhances{' '}</span>
            <span className="secondary-text">Everyday Pediatric</span>
            <span className=""> Care</span>
          </h2>
          <p className="    max-w-3xl mx-auto px-4">
            From growth tracking to timely consultations, Avexa ensures every child 
            receives the care they need, when they need it.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 lg:gap-12 max-w-4xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="group cursor-pointer flex"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden rounded-lg shadow-lg transition-all duration-300 ease-out group-hover:-translate-y-3 group-hover:shadow-2xl w-full flex flex-col">
                {/* Image Container */}
                <div className="relative h-40 md:h-44 overflow-hidden flex-shrink-0">
                  <img
                    src={feature.src}
                    alt={feature.alt}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  {/* Overlay gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Content */}
                <div className="px-4 py-4 md:px-5 md:py-5 flex items-center justify-center flex-grow">
                  <h3 className="   font-medium leading-relaxed text-center">
                    {feature.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .group {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        @media (prefers-reduced-motion: reduce) {
          .group {
            animation: none;
            opacity: 1;
          }
          
          .group:hover > div {
            transform: translateY(-8px);
          }
        }
      `}</style>
    </section>
  );
};

export default AvexaEnhancesSection;